import React, { useState, useEffect } from 'react';
import Modal from '../Modal';

const Main = ({notificationPath, currentUserId}) => {

  const [notificationComponent, setNotificationComponent] = useState(null);

  useEffect(() =>  {
    fetchNotificationType();
  }, []);

  const fireAmplitude = (eventType, data) => {
    $.ajax("/amplitudes", {
      dataType: "json",
      type: "POST",
      data: {
              event_type: eventType,
              user_id: currentUserId,
              ...data
            }
    })
  }

  const fetchNotificationType = () => {
    $.ajax({
      url: notificationPath,
      type: 'GET',
      success: (response) => {
        if(response.notification != false) {
          const notificationData = response.notification;
          // imports notification component dynamically i.e. GuestEditorModal
          import(`./${notificationData[0].modal}`).then((module) => {
            const ModalComponent = module.default;
            const componentInstance = <ModalComponent notifications={notificationData} currentUserId={currentUserId} handleModalClose={handleModalClose}/>;
            setNotificationComponent(componentInstance);
          });
        } else {
          setNotificationComponent(null);
        }
      }
    })
  }

  const openModal = () => {
    fireAmplitude('notificationBellClicked', {});
    Modal.open({
      children: notificationComponent
    })
  }

  const handleModalClose = (notifications) => {
    fireAmplitude('notificationAlertViewed', {notificationType: notifications[0].type});
    Modal.close();
    fetchNotificationType();
  }

  return (
    <React.Fragment>
      {notificationComponent && (
        <a onClick={openModal}  className='alert-bell'>
          <img src="https://public.cureus.com/bell-alerts/alert-bell.png" />
        </a>
      )}
    </React.Fragment>
  )
}

export default Main;